module.exports = __webpack_public_path__ + "files/d7369ff56e0ca3e13ee38d5d60b4bf9b.svg";